import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  DataGridView,
  Button,
  Row,
  Col,
} from "@neumetric/blueprint-lib/components";
import { useDispatch, useSelector } from "react-redux";
import { auditorActions, getAuditReportBlueprints } from "../../../store";

const ReportTypes = [
  { id: "default", label: "Default" },
  { id: "iso27001_2022", label: "ISO 27001:2022" },
  { id: "soc2_type2", label: "SOC 2 Type 2" },
];

const Columns = [
  {
    dataIndex: "reportType",
    typeRepresentation: "LINK",
    title: "Type",
    width: "50%",
  },
  {
    dataIndex: "status",
    typeRepresentation: "TEXT",
    title: "Status",
    width: "30%",
    classes: {
      content: "text-caps",
    },
  },
];

export const AuditReportBlurprintTrackerScreem = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reportBlueprints = useSelector(getAuditReportBlueprints);

  useEffect(() => {
    dispatch(auditorActions.fetchAuditReportBlueprints());
  }, []);

  const handleNewBlueprintClick = React.useCallback(() => {
    navigate(`/A/R/new`);
  }, []);

  const reportFormats = useMemo(() => {
    if (!Array.isArray(reportBlueprints)) {
      return reportBlueprints;
    }
    return reportBlueprints.map((bp) => {
      const modified = { ...bp, action: "View" };
      modified.reportType =
        ReportTypes.find((rt) => rt.id === bp.report_type)?.label ||
        bp.report_type;
      return modified;
    });
  }, [reportBlueprints]);

  return (
    <Row justify="between" className="h-100">
      <div className="w-55 pl-30 mt-50 h-80">
        <DataGridView
          columns={Columns}
          dataSource={reportFormats}
          EmptyComponent={
            <div className="w-100 h-100 d-flex align-center justify-center">
              <span className="ff-exo2 fs-14 text-subtitle">
                There are no Blueprints!
              </span>
            </div>
          }
          getCellSemantics={(column, record) => {
            const sematics = {};
            if (column.dataIndex === "reportType") {
              sematics.link = `${record.guid}`;
            }
            return sematics;
          }}
        />
      </div>
      <Col className="pr-30 mt-10">
        <Button icon="ADD" label="Create" onClick={handleNewBlueprintClick} />
      </Col>
    </Row>
  );
};
